import Component from './Tree.component';

export default Component;
